import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

// Depois do fim da beta (sex 16/10/2026 11:30, horário de Brasília) o site mostra só esta tela. O servidor já recusa o resto;
// a única coisa que continua é o /login, e só administradores conseguem entrar.
function isAdminToken() {
  try {
    const t = localStorage.getItem("pokeot_token");
    if (!t) return false;
    const p = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return ["admin", "owner"].includes(String(p.role || "").toLowerCase());
  } catch (e) { return false; }
}

export default function BetaGate({ children }) {
  const loc = useLocation();
  const [st, setSt] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/beta/status").then((r) => { if (alive) setSt(r.data); }).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const ended = !!(st && st.enforce && (st.ended || Date.now() + (st.now_ms - Date.now()) >= st.end_ms));
  if (ended && loc.pathname !== "/login" && !isAdminToken()) {
    return (
      <div className="fixed inset-0 z-[2000] flex items-center justify-center text-center text-white" style={{ background: "radial-gradient(circle at 50% 30%, #3a0508, #0b0305 70%)" }} data-testid="beta-closed">
        <div className="px-6 max-w-[520px]">
          <div className="text-6xl text-[#ff6a76]">&#9818;</div>
          <h1 className="mt-2 mb-3 text-3xl font-black uppercase italic tracking-[3px]">Beta encerrada</h1>
          <p className="text-[#e8c9cc] leading-relaxed">A fase de testes do <b>PKX Idle</b> terminou na sexta-feira, 16/10, às 11:30 (horário de Brasília).<br />Obrigado por jogar! Acompanhe o Discord para as próximas novidades.</p>
          <a href="/login" className="inline-block mt-6 text-[11px] font-bold text-white/30 hover:text-white/60 uppercase tracking-widest">Acesso da equipe</a>
        </div>
      </div>
    );
  }
  return children;
}
